import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Information,
  Sections,
  Publish,
  WrapperIcons,
  Title,
  TopSection,
  CategoryWrapper,
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { isClientEnv } from '@app/src/utils/validations';
import {
  CategoriesShimmer,
  fetchCategories,
  SectionOpportunity
} from '@app/src/views/Home/listProducts';
import { CATEGORIES } from '@app/src/config/categories';

const isClient = isClientEnv();

export const CoverPage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const categories = useSelector(state => state.categories.data);
  const isFetching: boolean = useSelector(state => state.categories.isFetching);
  const error: boolean = useSelector(state => state.categories.error);
  const [navigation, setNavigation] = useState([]);

  useEffect(() => {
    if (isClient) {
      (window as any).sessionStorage.removeItem('print');
    }
  }, []);

  useEffect(() => {
    if (categories && categories.length === 0) {
      dispatch(fetchCategories());
    }
    if (categories && categories.length > 0) {
      let newCategories = categories.filter((item) => item.order !== CATEGORIES.vehiculo.order);
      setNavigation([
        ...newCategories,
        categories[CATEGORIES.vehiculo.order - 1]
      ])
    }
  }, [categories]);

  const handleClick = (e, item) => {
    if (isClient) {
      e.preventDefault();
      const { paths, text } = item;
      const path = paths.purchasePrint.stepOne;
      history.push(path);
      pushDatalayer(text, path);
    }
  };

  const pushDatalayer = (categoryName: string, pathPage: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'BotonesCategorías',
        'eventAction': categoryName,
        'eventLabel': pathPage,
        'eventValue': 1
      })
    }
  };

  return (
    <React.Fragment>
      <TopSection id="economicos" data-scroll="economicos">
        <Information>¡Consigue la exposición que necesitas!</Information>
        <Sections>
          {
            isFetching || error
              ? <CategoriesShimmer />
              : navigation.map((item, index) =>
                <CategoryWrapper key={index}>
                  <WrapperIcons
                    color={item.color}
                    href={item.paths.purchasePrint.stepOne}
                    onClick={e => handleClick(e, item)}>
                    <Icon data-name={item.icon} width="42" height="42" fill="#fff" />
                  </WrapperIcons>
                  <Title>{item.text}</Title>
                </CategoryWrapper>
              )
          }
        </Sections>
        <Publish>Publica tus avisos impresos en los diarios más leídos del Perú</Publish>
      </TopSection>
      <SectionOpportunity />
    </React.Fragment>
  );
};

CoverPage.displayName = 'CoverPage';
